import React, { useEffect, useState } from 'react';
import './assets/css/style.scss';
import RegisterModal from '../RegisterModal/RegisterModal';
import logo from './../../../assets/images/white_logo.png';
import { Branch } from '../../../shared/interfaces';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaMapMarkerAlt, FaTiktok } from 'react-icons/fa';

function Footer() {
  // @ts-expect-error Reason for suppressing this
  const FacebookIcon = (): JSX.Element => <FaFacebookF />;
  // @ts-expect-error Reason for suppressing this
  const InstagramIcon = (): JSX.Element => <FaInstagram />;
  // @ts-expect-error Reason for suppressing this
  const TiktokIcon = (): JSX.Element => <FaTiktok />;
  // @ts-expect-error Reason for suppressing this
  const LinkedinIcon = (): JSX.Element => <FaLinkedinIn />;
  // @ts-expect-error Reason for suppressing this
  const GmapIcon = (): JSX.Element => <FaMapMarkerAlt />;

  const [selectedBranch, setSelectedBranch] = useState<Branch>();
  const [branches, setBranches] = useState<Branch[]>([]);
  const [showRegister, setShowRegister] = useState(false);

  useEffect(() => {
    fetch('https://strapi-production-a706.up.railway.app/api/branches?sort=order:ASC')
      .then((res) => res.json())
      .then((data) => {
        setBranches(data.data);
        setSelectedBranch(data.data[0]);
      })
      .catch((err) => console.error('Failed to fetch branches:', err));
  }, []);

  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-brand">
          <img src={logo} alt="Akropoli i Ri" />
          <p>Shkollë Filozofie që promovon kulturën dhe praktikon vullnetarizmin.</p>
        </div>

        <div className="footer-links">
          <div className="footer-column">
            <ul>
              {branches?.map((branch) => (
                <li key={branch.id}>
                  <button onClick={() => setSelectedBranch(branch)}>
                    {branch?.city}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-column">
            <h4>Kontakt - {selectedBranch?.name}</h4>
            <ul>
              <li>📞 {selectedBranch?.phoneNr}</li>
              <li>✉️ {selectedBranch?.email}</li>
              <li className="socials">
                <a
                  href={selectedBranch?.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FacebookIcon />
                </a>

                <a
                  href={selectedBranch?.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <InstagramIcon />
                </a>

                <a
                  href={selectedBranch?.tiktok}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <TiktokIcon />
                </a>

                <a
                  href={selectedBranch?.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LinkedinIcon />
                </a>
              </li>

              <li>
                <a
                  href={selectedBranch?.mapLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Adresa: {selectedBranch?.address} <GmapIcon />
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Rreth Nesh</h4>
            <ul>
              <li>
                <a href="/#kushjemi">Kush jemi</a>
              </li>
              <li>
                <a href="/#aktivitetet">Aktivitetet Tona</a>
              </li>
              <li>
                <a onClick={() => setShowRegister(true)}>Bëhu Vullnetar</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} Akropoli i Ri. Të gjitha të drejtat e rezervuara.
      </div>

      {showRegister && <RegisterModal show={showRegister} onHide={() => setShowRegister(false)} />}
    </footer>
  );
}

export default Footer;
